setTimeout(function(){
    /*theme.raQuickshop();*/  //QUICK VIEW ON PAGE LOAD
    rounders.init(); //COMPARE ON PAGE LOAD
},3000);

window.rounders = window.rounders || {};
rounders.replaceUrlParam = function(url, paramName, paramValue) {
    var pattern = new RegExp('(' + paramName + '=).*?(&|$)'),
        newUrl = url.replace(pattern, '$1' + paramValue + '$2');
    if (newUrl == url) {
        newUrl = newUrl + (newUrl.indexOf('?') > 0 ? '&' : '?') + paramName + '=' + paramValue;
    }
    return newUrl;
};

window.rounders = window.rounders || {};
rounders.init = function() {
    getCompareCountAll();

    /**List Height Match Start**/
    equalheightHome = function(container) {
      var currentTallest = 0,
          currentRowStart = 0,
          rowDivs = new Array(),
          elements,
          topPosition = 0,
          currentExtElementHeight = 0;
          tagElementHeight = 0;
      $(container).each(function() {
        elements = $(this);
        $(elements).height('auto');
        topPostion = elements.position().top;
        if (currentRowStart != topPostion) {
          for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
            rowDivs[currentDiv].find('.product-content .product-card__title').height(currentExtElementHeight);
            rowDivs[currentDiv].find('.product-information .product-tag-lists').height(tagExtElementHeight);
            rowDivs[currentDiv].height(currentTallest);
          }
          rowDivs.length = 0; // empty the array
          currentRowStart = topPostion;
          currentExtElementHeight = elements.find('.product-content .product-card__title').height();
          tagExtElementHeight = elements.find('.product-information .product-tag-lists').height();
          currentTallest = elements.height();
          rowDivs.push(elements);
        } else {
          rowDivs.push(elements);

          if (elements.find('.product-content .product-card__title').length > 0 && elements.find('.product-content .product-card__title').height() > currentExtElementHeight) {
            currentExtElementHeight = elements.find('.product-content .product-card__title').height();
          }

          if (elements.find('.product-information .product-tag-lists').length > 0 && elements.find('.product-information .product-tag-lists').height() > tagExtElementHeight) {
            tagExtElementHeight = elements.find('.product-information .product-tag-lists').height();
          }

          currentTallest = (currentTallest < elements.height()) ? (elements.height()) : (currentTallest);
        }
        for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
          rowDivs[currentDiv].find('.product-content .product-card__title').height(currentExtElementHeight);
          rowDivs[currentDiv].find('.product-information .product-tag-lists').height(tagExtElementHeight);
          rowDivs[currentDiv].height(currentTallest);
        }
      });
    }
    equalheightHome('.collection-mid-main .grid .grid__item');
    /**List Height Match Start**/
   
 
  	/* ================ CHANGE BACK IN STOCK FORM POSITION==============*/
	$( ".product-qty-add-buy-button" ).after( $( "#klaviyo-bis-iframe" ) );
    
    /*---- START PRODUCT DETAIL PAGE FILTER BUTTON ACTIVE-------*/
    $('.swatch > .swatch-element').click(function() {      
        $("#klaviyo-bis-iframe").hide();      	
      	if($(this).hasClass('available')) { 
			$(".product-form__item--payment-button, .product-form__cart-submit").show();
            $(".product-form__cart-submit.klaviyo-bis-trigger").hide();
        }
      	//if($(this).hasClass('soldout') && $( "product-form__cart-submit.klaviyo-bis-trigger" ).length ) {
        if($(this).hasClass('soldout') && $( ".klaviyo-bis-trigger" ).length > 0) {
			$(".product-form__item--payment-button, .product-form__cart-submit").hide(); 
            $(".product-form__cart-submit.klaviyo-bis-trigger").show();
        }
      
        var error_id = $(this).parent('.swatch').attr('data-option-index');
        $('.var-error-'+error_id).css('display','none');
      
        var filter = $(this).attr('data-filter');
        $('.' + filter).find('div').removeClass("selected");
        $(this).addClass('selected');
    });
    /*---- END PRODUCT DETAIL PAGE FILTER BUTTON ACTIVE-------*/


    /*---- START COLLECTION-PAGE-LIMIT -------*/
    $('.sort-per-page select.num').on('change', function() {
        var reExp = /limit=\\d+/;
        var url = window.location.href;
        url = url.toString();
        var limit = $(this).val(); //new value to replace hpr_id
        var reExp = new RegExp("[\\?&]" + 'limit' + "=([^&#]*)");
        if (url.indexOf('limit') != -1) {
            var delimeter = reExp.exec(url)[0].charAt(0);
            var newUrl = url.replace(reExp, delimeter + 'limit' + "=" + limit);
        } else {
            var separator = '';
            if (url.indexOf('?') != -1) { separator = '&'; } else { separator = '?'; }
            var newUrl = url + separator + "limit=" + $(this).val();
        }
        window.location.href = newUrl;
    });
    /*---- END COLLECTION-PAGE-LIMIT -------*/

    /*---- START CHANGE PRODUCT VIEW (GRID/LIST) -------*/
    $('.change-view').on('click', function() {
        var view = $(this).data('view'),
            url = document.URL,
            hasParams = url.indexOf('?') > -1;
        if (hasParams) {
            window.location = rounders.replaceUrlParam(url, 'view', view);
        } else {
            window.location = url + '?view=' + view;
        }
    });

    /*---- END CHANGE PRODUCT VIEW (GRID/LIST) -------*/
    $(document).on('click', '.compare-product', function() {
        var campcookies = [];
        var prodo = '';
        var cook = '';
        if (getCookie('compare')) {
            cook = getCookie('compare');
            if (cook != '') { prodo = cook; }
        }
        cook = cook.split(',');

        //console.log(cook);
        var handle = $(this).attr('data-handle');
        if (prodo == '') {
            campcookies.push(handle);
        } else {
            campcookies = prodo.split(',');
            campcookies.push(handle);
        }
        var count = campcookies.length - 1;
        if (count < 4) {
            if (cook.indexOf(handle) == -1) {
                setCookie('compare', campcookies.join(","));
                notificationPopup('Added to compare !');
                $(this).addClass('active-compare'); // on compare click active
                getCompareCount(handle);
            } else {
                notificationPopup('product is already added to compare list !');
            }
        } else {
            notificationPopup('You can compare max 4 products !');
        }
        //console.log(campcookies);
    });
    /*-------END SET COOKIE FOR COMPARE PAGE--------*/

    /*---- START REMOVE COMPARE PRODUCT -------*/
    $(".compare-remove").click(function() {
        var campcookies = [];
        var prodo = '';
        var cook = '';
        if (getCookie('compare')) {
            cook = getCookie('compare');
            if (cook != '') { prodo = cook; }
        }
        //console.log(cook);
        var handle = $(this).attr('data-handle');
        //console.log(handle);
        if (prodo == '') {} else {
            campcookies = prodo.split(',');
            //console.log(campcookies);
            var index = campcookies.indexOf(handle);
            if (index > -1) {
                campcookies.splice(index, 1);
            }
            setCookie('compare', campcookies.join(","));
            location.reload(true);
        }
    });
    /*---- END REMOVE COMPARE PRODUCT -------*/
};

/*-------START SET COOKIE FOR COMPARE PAGE--------*/
function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

/*-------START GET COOKIE ON COMPARE PAGE--------*/
function getCookie(name) {
    var value = "; " + document.cookie;
    var parts = value.split("; " + name + "=");
    if (parts.length == 2) return parts.pop().split(";").shift();
}

/*------------START COMPARE ON PRODUCT PAGE----------------*/
function getCompareCount(handle) {
    cookies = getCookie('compare');
    var cookieArray = cookies.split(',');
    var count = cookieArray.length;
    //alert('Count : ' + count);
    if (cookies != '') {
        if (count > 0) {
            $('#compareCount').removeClass('hide');
            $('#compareCount > .data-compare-count').html(count);
            /*---START DETAIL PAGE ACTIVE COMPARE */
            var btnhandle = $('.wishlist-compare-btn .compare-product').attr('data-handle');
            if (btnhandle == handle) {
                $('.wishlist-compare-btn .compare-product').addClass('active-compare');
            }
            /*---END DETAIL PAGE ACTIVE COMPARE */
        }
    } else {
        $('#compareCount').addClass('hide');
    }
}
/*------------END COMPARE ON PRODUCT PAGE----------------*/

/*------------START COMPARE PRODUCT (COUNT & ACTIVE) ----------------*/
function getCompareCountAll() {
    var cook = '';
    if (getCookie('compare')) {
        cook = getCookie('compare');
    }
    if (cook != '') {
        var comparecookie = cook.split(',');
        var count = comparecookie.length;
        if (count > 0) {
            $('#compareCount').removeClass('hide');
            $('#compareCount > .data-compare-count').html(count);
            /*---START LIST PAGE ACTIVE COMPARE */
            var handleList = $(".product-icon .compare-product").map(function() {
                var p_id = $(this);
                comparecookie.forEach(function(element, key) {
                    if (p_id.attr("data-handle") == element) {
                        p_id.addClass('active-compare'); //LIST page compare button
                    }
                });
            }).get();
            /*---END LIST PAGE ACTIVE COMPARE */
            /*---START LIST PAGE ACTIVE COMPARE */
            var handleList = $(".product-icon .compare-product").map(function() {
                var p_id = $(this);
                comparecookie.forEach(function(element, key) {
                    if (p_id.attr("data-handle") == element) {
                        p_id.addClass('active-compare'); //LIST page compare button
                    }
                });
            }).get();
            /*---END LIST PAGE ACTIVE COMPARE */
            /*---START DETAIL PAGE ACTIVE COMPARE */
            comparecookie.forEach(function(element, key) {
                var btnhandle = $('.wishlist-compare-btn .compare-product').attr('data-handle');
                if (btnhandle == element) {
                    $('.wishlist-compare-btn .compare-product').addClass('active-compare');
                }
            });
            /*---END DETAIL PAGE ACTIVE COMPARE */
        }
    } else {
        $('#compareCount').addClass('hide');
    }
}
/*------------END COMPARE PRODUCT (COUNT & ACTIVE) ----------------*/

/*-------START GET COOKIE ON COMPARE PAGE--------*/
setTimeout(function() {
    var cook = '';
    if (getCookie('compare')) {
        cook = getCookie('compare');
    }
    if (cook != '') {
        var comparecookie = cook.split(',');
        var count = comparecookie.length;
        $("#compare-products").empty();
        $("#compare-products").append("<ul id='compare-ul'></ul>");
        if (count > 0) {
            comparecookie.forEach(function(element, key) {
                $.ajax({
                    url: "/products/" + element + "?view=compare",
                    success: function(t) {
                        $("#compare-ul").prepend('<li class="compare-list grid__item grid__item--collection-template small--one-half medium-up--one-quarter">' + t + '</li>');
                        $(rounders.init);
                    }
                });
            });
        }
    } else {
        $("#compare-products").empty();
        $('.product-compare-empty').show(); //it will be visible when 0 product in to compare cart
        //$("#compare-products").append("<p style='margin: 60px 0px 20px 0px; text-align: center;'>There is no product for compare !</p>");
    }
},3000);
/*-------END GET COOKIE ON COMPARE PAGE--------*/

setTimeout(function() {
    /*-------START IMAGE SWITCHER--------*/
    imgswitches();
    $('.single-option-selector').change(function() {
        imgswitches();
    });

    function imgswitches() {
        var atoptions = [];
        $(".single-option-selector").each(function(index) { atoptions.push($(this).val()); });
        var selected_option = atoptions.join("-");
        if ($('img[alt="Load image into Gallery viewer, ' + selected_option + '"]').length > 0) {
            $('ul.product-single__thumbnails > .grid__item').css("display", "none");
            $('img[alt="Load image into Gallery viewer, ' + selected_option + '"]').parent().parent('li').css("display", "block");
        }
    }
    /*-------END IMAGE SWITCHER--------*/

    /*-------START SEARCH--------*/
    $("#searchHd-OTHER").keyup(function(event) {
        var resultsList = $('.search-bar__form').find('#livesearch');
        var search = $(this).val();
        if (search.length > 0) {
            resultsList.empty();
            $.getJSON("/search/suggest.json", {
                s: search,
                resources: {
                    "types": ["product"],
                    "limit": 4,
                    "unavailable_products": "bury"
                }
            }).done(function(response) {
                var productSuggestions = response.resources.results.products;
                //console.log(productSuggestions);
                if (productSuggestions.length > 0) {
                    var firstProductSuggestion = productSuggestions[0];
                    $.each(productSuggestions, function(index, item) {
                        var filename = (item.image).substring((item.image).lastIndexOf('/') + 1);
                        var fileonly = filename.split('.').slice(0, -1).join('.');
                        var thumbimage = (item.image).replace(fileonly, fileonly + '_30X');
                        //console.log(thumbimage);
                        var link = $('<a></a>').addClass('autocomplete__link media').attr('href', item.url);
                        link.append('<figure class="autocomplete__fig media__fig"><img src="' + thumbimage + '" class="media__img" alt="' + item.title + '" /></figure>');
                        link.append('<div class="media__body"><span class="title tile__title">' + item.title + '</span><span class="title tile__price">' + Shopify.formatMoney(item.price) + '</span></div>');
                        link.wrap('<li class="autocomplete__item"></li>');
                        resultsList.append(link.parent());
                    });
                }
            });
        } else {
            resultsList.empty();
        }
    });
    /*-------END SEARCH--------*/
},3000);

/*-------START HEADER SCROLL--------*/
$(window).on("scroll", function() {
    var HscrollTop = $(window).scrollTop();
    if (HscrollTop >= 50) {
        $('body').addClass('fixed-header');
    } else {
        $('body').removeClass('fixed-header');
    }
});
$(window).trigger('scroll');
/*-------END HEADER SCROLL--------*/

/*------------START NOTIFICATION POPUP----------------*/
function notificationPopup(text) {
    $('#notificationPopup > span').html(text);
    $('#notificationPopup').addClass('show');
    setTimeout(function() { $('#notificationPopup').removeClass('show'); }, 3000);
}
/*------------END NOTIFICATION POPUP----------------*/

/*------------START QUANTITY UP/DOWN FOR PRODUCT PAGE ----------------*/
/*$('<div class="quantity-nav"><div class="quantity-button quantity-up"></div><div class="quantity-button quantity-down"></div></div>').insertAfter('.cart__qty input, .product-form__item--quantity input');*/
$('.cart__qty, .product-form__item--quantity').each(function() {
    var spinner = jQuery(this),
        input = spinner.find('input[type="number"]'),
        btnUp = spinner.find('.quantity-up'),
        btnDown = spinner.find('.quantity-down'),
        min = input.attr('min'),
        max = input.attr('max');
    btnUp.click(function() {
        var oldValue = parseFloat(input.val());
        if (oldValue >= max) {
            var newVal = oldValue;
        } else {
            var newVal = oldValue + 1;
        }
        spinner.find("input").val(newVal);
        spinner.find("input").trigger("change");
    });
    btnDown.click(function() {
        var oldValue = parseFloat(input.val());
        if (oldValue <= min) {
            var newVal = oldValue;
        } else {
            var newVal = oldValue - 1;
        }
        spinner.find("input").val(newVal);
        spinner.find("input").trigger("change");
    });
});
/*------------END QUANTITY UP/DOWN FOR PRODUCT PAGE ----------------*/

/*------------START MOBILE FILTER FOR PRODUCT LIST PAGE ----------------*/
$('.shop_filter').click(function() {
    $('.filters-prt').toggleClass('filters-open');
    $('.filters-overlay').toggleClass('ftr-overlay-open');
});
$('.filters-overlay').click(function() {
    $('.filters-prt').removeClass('filters-open');
    $('.filters-overlay').removeClass('ftr-overlay-open');
});
/*------------END MOBILE FILTER FOR PRODUCT LIST PAGE ----------------*/

/*------------START MOBILE FILTER FIXED FOR PRODUCT LIST PAGE ----------------*/
$(window).scroll(function () {
        var fixSidebar = $('.site-header__mobile-nav').innerHeight();
        var contentHeight = $('.header-bottom-wrapper').innerHeight();
        var totalHeight = fixSidebar + contentHeight;

        if ($(window).scrollTop() >= totalHeight) {
            $('.filter-row').addClass('fixed-filter');
        } else {
            $('.filter-row').removeClass('fixed-filter');
        }
      });
/*------------END MOBILE FILTER FIXED FOR PRODUCT LIST PAGE ----------------*/
/*------------Cart Model Popup Start ----------------*/
    $('.cartmodel-btns .cancel-btn, .cartmodel-close').click(function(){
      $('.cartmodel-popup-main, .cartmodel-popup-overlay, .cartmodel-popup-overlay').removeClass('modelshow');
    });
/*------------Cart Model Popup End ----------------*/    

/**Set up Reward for Writing Product Review**/
  $(document).on('click', '.prodct-review-scroll', function() {
    
      $("html,body").animate({
              scrollTop: jQuery("#shopify-product-reviews").offset().top - 100
          },
          "slow"
      );
});  

/**Set up Reward for Writing Product Review**/
